import { AccessRoles } from '../../../../../../shared/auth';

const getAbilityForAccepting = (roles: string[]) => {
  return roles.includes(AccessRoles.APPROVAL_ACCESS);
};

export default getAbilityForAccepting;
